import { createClient } from '@supabase/supabase-js';
import { APP_CONFIG } from './app-config';

// Use centralized configuration shared with admin project
const supabaseUrl = APP_CONFIG.supabase.url;
const supabaseAnonKey = APP_CONFIG.supabase.anonKey;

const getProjectRefFromUrl = (url: string): string => {
  try {
    return new URL(url).hostname.split('.')[0] || 'unknown';
  } catch {
    return 'unknown';
  }
};

export const AUTH_STORAGE_KEY = `sb-${getProjectRefFromUrl(supabaseUrl)}-auth-token`;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: AUTH_STORAGE_KEY,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  global: {
    headers: {
      'x-client-info': 'supabase-js-web'
    }
  }
});
